export default __webpack_public_path__ + "static/media/dynamic.53147562.png";